import React from 'react';
import cn from 'classnames';

import strings from '../../lang/lang';
import { Button } from '../../elements';
import { appsActions } from '../../redux/reducers/apps';
import { ReactComponent as PokerFaceIcon } from '../../styles/icon/poker-face.svg';
import { ReactComponent as PlusIcon } from '../../styles/icon/plus-white.svg';
import { useAppDispatch } from '../../hooks/useRedux';

import app from './App.module.scss';

function CreateFirstApp() {
  const dispatch = useAppDispatch();
  return (
    <div className={cn(app.app, { [app.app__white]: false })}>
      <div className={app.app__container}>
        <div className={app.app__box}>
          <div className={app.app__title}>
            <h1>{strings.appList.text.title}</h1>
          </div>
          <div className={app.app__not_app}>
            <PokerFaceIcon />
            <h4>{strings.appList.text.noApps}</h4>
            <div className={app.app__text}>
              <p>{strings.appList.text.createFirstApp}</p>
            </div>
            <div className={app.app__btn_create_center}>
              <Button
                name={strings.appList.buttons.create}
                type="submit"
                variant="primary"
                className="reverse"
                secondaryClassName="create"
                onClick={() => dispatch(appsActions.toogleCreateAppModal(true))}
              >
                <PlusIcon />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateFirstApp;
